import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
  type CognitoUserSession,
} from "amazon-cognito-identity-js";
import { config } from "./config";

function pool(): CognitoUserPool {
  return new CognitoUserPool({
    UserPoolId: config().userPoolId,
    ClientId: config().userPoolClientId,
  });
}

export async function signUp(email: string, password: string): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    pool().signUp(email, password, [], [], (error) => (error ? reject(error) : resolve()));
  });
}

export async function confirmSignUp(email: string, code: string): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    new CognitoUser({ Username: email, Pool: pool() }).confirmRegistration(
      code,
      true,
      (error) => (error ? reject(error) : resolve()),
    );
  });
}

export async function signIn(email: string, password: string): Promise<CognitoUserSession> {
  return await new Promise<CognitoUserSession>((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: pool() });
    user.authenticateUser(new AuthenticationDetails({ Username: email, Password: password }), {
      onSuccess: resolve,
      onFailure: reject,
      newPasswordRequired: () => reject(new Error("A password change is required")),
    });
  });
}

export async function currentSession(): Promise<CognitoUserSession | null> {
  const user = pool().getCurrentUser();
  if (!user) return null;
  return await new Promise((resolve) => {
    user.getSession((error: Error | null, session: CognitoUserSession | null) => {
      resolve(error || !session?.isValid() ? null : session);
    });
  });
}

export function signOut(): void {
  pool().getCurrentUser()?.signOut();
}
